import script from "./NetworksCompanyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NetworksCompanyComponent.vue?vue&type=script&setup=true&lang=js"

import "./NetworksCompanyComponent.vue?vue&type=style&index=0&id=425d4688&lang=css"

const __exports__ = script;

export default __exports__